import React from 'react';
import CommunityImg from '../CommunityImg/CommunityImg';
import './Button.scss';

const Button = ({label, onClick, cls, bgColor, imgSrc, props}) => {
  return (
    <button 
      style={bgColor ? {backgroundColor : bgColor, borderColor: bgColor} : {}}
      className={`${cls} community-btn`} 
      onClick={onClick} 
      {...props}
    > 
      {label} 
      {
        imgSrc ? <CommunityImg className="btn-image-cls" src={imgSrc} /> : null
      }
    </button>
  )
}

export default Button; 